const takeBoosterConfigsModel = vm => ({
  title: vm.$gettext('Take Booster Configs'),
  endpoint: 'take-booster-configs',
  allowNew: true,
  allowDelete: true,
  countrize: 'region.country_iso_code',
  fields: [
    {
      key: 'id',
      sortable: true
    },
    {
      key: 'reference',
      label: vm.$gettext('Reference'),
      sortable: true,
      editable: true,
      required: true
    },
    {
      key: 'region_id',
      label: vm.$gettext('Region'),
      sortable: true,
      editable: true,
      required: true,
      description: vm.$gettext('Region ID')
    },
    {
      key: 'type',
      label: vm.$gettext('Type'),
      sortable: true,
      editable: true,
      required: true,
      description: vm.$gettext(
        'Config type, wether this is for reducing or increasing the courier commission. Must be one of: <strong>boost</strong> or <strong>give</strong>.'
      )
    },
    {
      key: 'general_coefficient',
      label: vm.$gettext('General Coefficient'),
      editable: true,
      description: vm.$gettext('General coefficient factor (variable M in formula)')
    },
    {
      key: 'distance_coefficient',
      label: vm.$gettext('Distance Coefficient'),
      editable: true,
      description: vm.$gettext('Distance coefficient factor (variable D in formula)')
    },
    {
      key: 'stops_coefficient',
      label: vm.$gettext('Stops Coefficient'),
      editable: true,
      description: vm.$gettext('Stops coefficient factor (variable S in formula)')
    },
    {
      key: 'time_coefficient',
      label: vm.$gettext('Time Coefficient'),
      editable: true,
      description: vm.$gettext('Time coefficient factor (variable H in formula)')
    },
    {
      key: 'adjustment_constant',
      label: vm.$gettext('Adjustment Constant'),
      editable: true,
      description: vm.$gettext('Adjustment constant (variable C in formula)')
    },
    {
      key: 'apply_confirmed',
      label: vm.$gettext('Apply to CONFIRMED'),
      editable: true,
      type: Boolean,
      description: vm.$gettext('Indicates if this configs applies when tours are marked as confirmed')
    },
    {
      key: 'apply_waiting',
      label: vm.$gettext('Apply to WAITING'),
      editable: true,
      type: Boolean,
      description: vm.$gettext("Indicates if this configs applies when tours are send to 'waiting' list")
    },
    {
      key: 'time_from',
      label: vm.$gettext('Time From'),
      editable: true,
      type: 'time',
      description: vm.$gettext(
        'Within <code>time_to</code> configures a timming range, outside of it this time is the default. Must be lower than <code>time_to</code>'
      )
    },
    {
      key: 'time_to',
      label: vm.$gettext('Time To'),
      editable: true,
      type: 'time',
      description: vm.$gettext(
        'Time up to the rule applies considering current time, outside of the range is <code>time_to</code>. Must be higher than <code>time_from</code>'
      )
    },
    {
      key: 'enabled',
      label: vm.$gettext('Enabled'),
      editable: true,
      type: Boolean
    }
  ],
  filters: ['id', 'reference', 'region_id', 'region.country_iso_code', 'enabled'],
  includes: ['region']
})

export default takeBoosterConfigsModel
